import { Button } from "@/components";
import { VehicleParameterItem } from "@/components";
import React, { useMemo } from "react";

export interface VehicleIdentificationData {
  brand?: string;
  model?: string;
  generation?: string;
  version?: string;
  productionYear?: string;
  modelYear?: string;
  vin?: string;
  countryOfOrigin?: string;
  faceliftYear?: string;
  productionStartDate?: string;
  productionEndDate?: string;
}

export interface HSPVehicleIdentificationProps {
  data: VehicleIdentificationData;
  onShowFullVehicleCard?: () => void;
}

export const HSPVehicleIdentification: React.FC<
  HSPVehicleIdentificationProps
> = ({ data }) => {
  const fillColor = useMemo(() => "#A4B2C0", []);
  return (
    <div className="mt-6 w-full lg:mt-10">
      <div className="grid grid-cols-1 gap-5 items-center py-5 bg-white rounded-2xl border border-violet-100 border-solid md:grid-cols-2 lg:grid-cols-3">
        {data.brand && data.model && (
          <VehicleParameterItem
            label="Marka i model"
            value={`${data.brand} ${data.model}`}
            fillColor={fillColor}
            icon="shield"
          />
        )}

        {data.generation && (
          <VehicleParameterItem
            label="Generacja"
            value={data.generation}
            icon="sun"
            fillColor={fillColor}
          />
        )}

        {data.version && (
          <VehicleParameterItem
            label="Wersja"
            value={data.version}
            fillColor={fillColor}
            icon="car"
          />
        )}

        {data.productionYear && data.modelYear && (
          <VehicleParameterItem
            label="Rok produkcji i rok modelowy"
            value={`${data.productionYear} / ${data.modelYear}`}
            fillColor={fillColor}
            icon="calendar-date"
          />
        )}

        {data.vin && (
          <VehicleParameterItem
            label="Numer VIN"
            value={data.vin}
            fillColor={fillColor}
            icon="vin-number"
          />
        )}

        {data.countryOfOrigin && (
          <VehicleParameterItem
            label="Kraj pochodzenia"
            value={data.countryOfOrigin}
            fillColor={fillColor}
            icon="location-pin"
          />
        )}

        {data.faceliftYear && (
          <VehicleParameterItem
            label="Data faceliftingu"
            value={data.faceliftYear}
            fillColor={fillColor}
            icon="excel-file"
          />
        )}

        {data.productionStartDate && (
          <VehicleParameterItem
            label="Data rozpoczęcia produkcji"
            value={data.productionStartDate}
            fillColor={fillColor}
            icon="calendar-date"
          />
        )}

        {data.productionEndDate && (
          <VehicleParameterItem
            label="Data zakończenia produkcji"
            value={data.productionEndDate}
            fillColor={fillColor}
            icon="calendar-date"
          />
        )}
      </div>

      <div className="flex justify-start mt-8">
        <Button
          variant="gold"
          onClick={() => (window.location.href = "#dane-techniczne")}
        >
          Zobacz pełną kartę pojazdu
        </Button>
      </div>
    </div>
  );
};
